export default "__VITE_ASSET__CKnBuq4k__"